import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Box } from "@mui/material";

interface LeftNavControllerType {
  isLeftNavExpanded: boolean;
  onLeftNavResize: () => void;
}

export const LeftNavController = (props: LeftNavControllerType) => {
  const { isLeftNavExpanded, onLeftNavResize } = props;

  const leftNavControllerStyles = {
    marginBottom: "24px",
  };

  return (
    <Box onClick={() => onLeftNavResize()} sx={leftNavControllerStyles}>
      {isLeftNavExpanded ? <ArrowBackIos /> : <ArrowForwardIos />}
    </Box>
  );
};
